/** @format */

import React, { useState, useEffect, useRef } from 'react'
import { Table, Button, Modal, Input, Popover, message, Upload } from 'antd'
import AliUploader from '../../component/AliUploader/linggan_aliupload'
import { UploadToOss } from '../../util/uploadTool';
import { caseBanner, updateCaseBanner } from '../../api'

import './index.less'
// const dirname = 'caseManage/'
export default () => {
  const [carouselList, setCarouselList] = useState([])

  const [editCaseId, setEditCaseId] = useState()
  const [editImg, setEditImg] = useState()
  const [editId, setEditId] = useState()
  const [editTitle, setEditTitle] = useState()

  // status
  const [listLoading, setListLoading] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [ossData, setOssData] = useState()

  const dirname = 'caseManage/'
  const imgPrefix = 'https://qingtu-image-originals.oss-cn-shanghai.aliyuncs.com'
  const token = {
    host: 'https://image.znzgo.com/',
    ALI_HOST: imgPrefix,
    // access_key_id: 'LTAI5t8ubGymdJDnqyAe2EM2', // oss的key_id
    // access_key_secret: 'zfkvIN3eft7FrYJqfCRDURjGxhSHcF', // oss的secret
    OSS_ENDPOINT: 'oss-cn-shanghai.aliyuncs.com', // 自己oss服务器的配置信息
    OSS_BUCKET: 'qingtu-image-originals', // 自己oss服务器的配置信息
    OSS_REGION: 'oss-cn-shanghai',
  }

  useEffect(() => {
    getCaseBanner()
  }, [])

  const getCaseBanner = () => {
    setListLoading(true)
    caseBanner()
      .then((res) => {
        if (res?.error?.errorCode == 0 && res?.data) {
          setCarouselList(res.data)
        }
      })
      .finally(() => {
        setListLoading(false)
      })
  }

  const handleSubmitChange = () => {
    if (!editCaseId) {
      message.error('请输入案例ID')
      return
    }
    if (!editImg) {
      message.error('请上传图片')
      return
    }
    setEditVisible(false)
    updateCaseBanner({
      id: editId,
      caseId: editCaseId,
      title: editTitle,
      imageUrl: editImg,
    })
      .then((res) => {
        if (res?.error?.code === 0) {
          message.success('保存成功')
        }
      })
      .finally(() => {
        getCaseBanner()
      })
  }

  const handleCloseModal = () => {
    setEditVisible(false)
    setEditCaseId()
    setEditImg()
    setEditTitle()
  }

  const columns = [
    {
      title: '序值',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '案例ID',
      dataIndex: 'caseId',
      key: 'caseId',
    },
    {
      title: '轮播图',
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      render: (text) => (
        <Popover
          placement='right'
          content={<img className='carouselImgPopover' src={text} />}
        >
          <div className='rowImgContainer'>
            <img src={text} />
          </div>
        </Popover>
      ),
    },
    {
      title: '标题',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '维护时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
    },
    {
      title: '操作',
      key: 'operation',
      render: (text, data) => (
        <Button
          onClick={() => {
            setEditCaseId(data.caseId)
            setEditImg(data.imageUrl)
            setEditId(data.id)
            setEditTitle(data.title)
            setEditVisible(true)
          }}
        >
          编辑
        </Button>
      ),
    },
  ]

  const beforeUpload = (file) => {
    const img_type = ['image/png', 'image/jpeg', 'image/jpg','image/gif'];
    const img_size = file.size / 1024 / 1024;
    if (!img_type.includes(file.type)) {
      return false;
    }
    if (img_size > 50) {
      return false;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    const OssToken = token;
    reader.onloadend = async () => {
      // 使用ossupload覆盖默认的上传方法
      message.loading('上传中');
      UploadToOss({ token: OssToken }, OssToken.ALI_HOST, file)
        .then((data) => {
          console.debug('file',file)
          let sourceLink = OssToken.host + '/' + data.name;
          setEditImg(sourceLink)
          console.debug('data', data)
          message.success('上传成功！')
        })
        .catch((err) => {
          message.destroy();
          message.error('上传失败，请重试~');
        })
        .finally(() => {
          message.destroy();
        });
    };

    return false;
  };
  return (
    <div className='caseHomeCarouselContainer'>
      <div className='title'>案例频道轮播</div>
      <Table
        columns={columns}
        loading={listLoading}
        dataSource={carouselList}
        pagination={false}
      />
      <Modal
        title='编辑'
        visible={editVisible}
        forceRender
        cancelText='取消'
        okText='保存'
        onOk={handleSubmitChange}
        onCancel={handleCloseModal}
      >
        <div className='carouselEditModalContainer'>
          <div className='editRow'>
            <div className='label'>案例ID：</div>
            <Input
              value={editCaseId}
              className='inputor'
              onChange={(e) => {
                setEditCaseId(e.target.value)
              }}
            />
          </div>
          <div className='editRow'>
            <div className='label'>标题：</div>
            <Input
              value={editTitle}
              className='inputor'
              onChange={(e) => {
                setEditTitle(e.target.value)
              }}
            />
          </div>
          <div className='editRow'>
            <div className='label'>轮播图：</div>

            <Upload
              // {...props}
              showUploadList={false}
              beforeUpload={beforeUpload}
            >
              <Button  type='primary'>
                上传
              </Button>
            </Upload>
          </div>
          <div className='imgContainer'>{editImg && <img src={editImg} />}</div>
        </div>
      </Modal>

      {/* <AliUploader
        id='upload_img_0'
        dirname={dirname}
        fileUploaded={(up, file, info, uploaded_object_name) => {
          console.log(uploaded_object_name)
          setEditImg(`${imgPrefix}/${uploaded_object_name}`)
        }}
        uploaderInit={(func) => (uploaderInit0.current = func)}
        token={token}
      /> */}
    </div>
  )
}
